import { render } from "./TextInput.vue?vue&type=template&id=46b70a88&scoped=true&ts=true"
import script from "./TextInput.vue?vue&type=script&lang=ts"
export * from "./TextInput.vue?vue&type=script&lang=ts"

import "./TextInput.vue?vue&type=style&index=0&id=46b70a88&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Xabie\\OneDrive\\Desktop\\Proyectos\\Dream\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b70a88"]])

export default __exports__